// extracted by mini-css-extract-plugin
export var container = "block-projects-desktop-module--container--77974";
export var marginBottom = "block-projects-desktop-module--marginBottom--22ccz";